export default {
  loading: {
    id: 'bo_seller.orders.drawers.fix_order_issue.out_of_stock_loading',
    defaultMessage: 'Loading...',
  },
  orderNotFound: {
    id: 'bo_seller.orders.drawers.fix_order_issue.out_of_stock_order_not_found',
    defaultMessage: 'Order not found',
  },
} as const
